import * as React from 'react';
import type { SVGProps } from 'react';
const SvgWarningTriangle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={14}
    fill="none"
    viewBox="0 0 15 14"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.462}
      d="M6.399 1.252.877 10.718c-.408.7.097 1.58.907 1.58h11.044c.81 0 1.315-.88.907-1.58L8.213 1.252a1.05 1.05 0 0 0-1.814 0M7.306 4.422v3.413"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.462}
      d="M7.306 10.197a.262.262 0 1 1 0-.525M7.306 10.197a.262.262 0 1 0 0-.525"
    />
  </svg>
);
export default SvgWarningTriangle;
